import { useMemo } from 'react';
import { useAppContext } from '@ids/context';

const useQueryParams = () => {
    const {
        location: { search },
    } = useAppContext();

    return useMemo(() => new URLSearchParams(search), [search]);
};

export default useQueryParams;
